import React from 'react';
import { connect } from 'react-redux';
import { Section, Title, Modal } from '@common/components';
import { popIn } from '@common/utils/services';
import VenueForm from '../Form';
import { createVenue } from '@resources/Venue/actions';
import { useIntl } from 'react-intl';

const Create = (props) => {
	const { module, createVenue, visible, onCancel } = props;
	const intl = useIntl();

	const handleSubmit = (data) => {
		return createVenue(data)
			.then((response) => {
				popIn(
					'success',
					intl.formatMessage({
						id: 'message.success.venue.create',
						defaultMessage:
							'A new Venue has been successfully created',
					})
				);

				onCancel && onCancel();
			})
			.catch((err) => Promise.reject(err));
	};

	return (
		<Modal visible={visible} onCancel={() => onCancel && onCancel()}>
			<Title>
				{intl.formatMessage({
					id: 'common.new.venue',
					defaultMessage: 'Create Venue',
				})}
			</Title>
			<Section className="mb-5">
				<VenueForm onSubmit={handleSubmit} {...props} module={module} />
			</Section>
		</Modal>
	);
};

const mapStateToProps = ({
	items,
	modules,
	cellGroup,
	event,
	facility,
	ministry,
	mission,
	organization,
	prayer,
	testimony,
	service,
}) => {
	return {
		items,
		modules,
		cellGroup,
		event,
		facility,
		ministry,
		mission,
		organization,
		prayer,
		testimony,
		service,
	};
};

export default connect(mapStateToProps, {
	createVenue,
})(Create);
